














import { Component, Vue, Prop } from "vue-property-decorator"
import Tab from "@/components/Tab.vue" // @ is an alias to /src

@Component({
  components: {
    Tab,
  },
})
export default class NewArticle extends Vue {
  @Prop()
  private articleId?: number
}
